<template>
  <div class="condition">
    <div class="img">
      <img src="@/assets/images/p5.png" alt="">
    </div>
    <div class="content">
      <div class="title1">代理博洋生活</div>
      <div class="title2">条件：</div>
      <div class="text">
        <p>暂无</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data(){
    return{
      
    }
  }
}
</script>

<style scoped>
.condition .img img{
  display: block;
  max-width: 100%;
  margin-bottom: 60px;
}
.condition .content .title1{
  font-size: 18px;
}
.condition .content .title2{
  font-size: 14px;
  line-height: 34px;
  background-color: #5e7987;
  color: #fff;
  padding: 0 10px;
  margin-top: 15px;
}
.condition .content .text{
  font-size: 12px;
  color: #2a2a2a;
  line-height: 35px;
  padding: 30px 0;
}
</style>


